import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import type { QuickActionData } from '@/hooks/useHomeData';

interface QuickActionsProps {
  items: QuickActionData[];
}

export function QuickActions({ items }: QuickActionsProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section>
      <div className="home-section-title">{t('home.section_quick_actions')}</div>
      <div className="qa-row">
        {items.map((qa) => (
          <button
            key={qa.id}
            type="button"
            className="qa-btn"
            onClick={() => qa.to && navigate(qa.to)}
          >
            <div className="qa-icon" data-tone={qa.iconTone ?? null}>
              <span className="material-symbols-outlined">{qa.icon}</span>
            </div>
            <div className="qa-label">{t(qa.labelKey)}</div>
          </button>
        ))}
      </div>
    </section>
  );
}
